/* eslint-disable no-param-reassign */
export const getRandomInteger = (min: number, max: number): number => {
  // Ensure the parameters are integers
  min = Math.ceil(min);
  max = Math.floor(max);
  // Generate a random integer between min and max (inclusive)
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

/**
 * Returns a UUID v4 string. Prefers crypto.randomUUID(), which is only exposed
 * in secure contexts (HTTPS/localhost) and throws where it isn't available, so
 * we fall back to a Math.random()-based v4 when it's missing or unusable. The
 * fallback is not cryptographically strong - only use this where a collision-
 * resistant opaque id is enough (e.g. a client-side conversation id), not for
 * anything security-sensitive.
 */
export const generateUuid = (): string => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    // Fall through to the Math.random() implementation below.
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    // For 'y' the RFC 4122 variant requires one of 8, 9, a, b.
    const value = char === 'x' ? random : (random % 4) + 8;
    return value.toString(16);
  });
};
